import { useState, useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { debounce } from "lodash";

export default function useFilters({ columns, action }) {
  const dispatch = useDispatch();
  const [rowPerPage, setRowPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const initialFilters = columns.map((c) => c.filter).filter((f) => f);
  const [filters, setFilters] = useState([...initialFilters]);

  const actionDebounced = useCallback(
    debounce(
      (dispatch, page, rowPerPage, filters) =>
        dispatch(action(page, rowPerPage, filters)),
      1000
    ),
    []
  );

  useEffect(() => {
    actionDebounced(dispatch, page, rowPerPage, filters);
  }, [dispatch, filters, actionDebounced, page, rowPerPage]);

  const handlePageChange = useCallback(
    (event, newPage) => {
      setPage(newPage);
    },
    [setPage]
  );

  const handleRowPerPageChange = useCallback(
    (event) => {
      setRowPerPage(+event.target.value);
    },
    [setRowPerPage]
  );

  const handleFilterChange = useCallback(
    (e, filterValue, filterName) => {
      setFilters(
        filters.map((f) =>
          f.field === filterName ? { ...f, value: filterValue } : f
        )
      );
    },
    [filters, setFilters]
  );

  return {
    filters,
    handleFilterChange,
    rowPerPage,
    handleRowPerPageChange,
    page,
    handlePageChange,
  };
}
